import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/**
 * Sans configuration, l'app afficherait une carte muette et des erreurs
 * réseau opaques. Mieux vaut le dire franchement — c'est l'oubli le plus
 * probable au premier lancement comme au premier déploiement.
 */
export const isConfigured = Boolean(url && anonKey)

export const configError = isConfigured
  ? null
  : "Supabase n'est pas configuré. En local : copier .env.example vers .env.local et " +
    'y mettre VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY. ' +
    'En production : définir ces deux variables dans les réglages du site Cloudflare Pages, ' +
    'puis redéployer (elles sont lues au build, pas à l\'exécution).'

/**
 * Fragment d'URL capturé à l'import, impérativement AVANT createClient.
 *
 * detectSessionInUrl lit le fragment puis l'efface, y compris quand il porte
 * une erreur plutôt qu'un jeton. Le relire ensuite ne rendrait qu'une chaîne
 * vide, et l'échec de connexion resterait sans explication à l'écran.
 * L'ordre de ces deux instructions est donc porteur de sens.
 */
export const initialHash = typeof window === 'undefined' ? '' : window.location.hash

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // La session revient dans l'URL après le clic sur le lien magique.
        detectSessionInUrl: true,
      },
    })
  : null
